import Reflux from "reflux";

/**
 * Triggered from the login page towards the session store that a potential login should be handled.
 */
export const LoginActions = {
	LoginCustomer: Reflux.createAction(["LoginCustomer"]),
	LoginEmployee: Reflux.createAction(["LoginEmployee"]),
};
